import { useRadioGroup } from '@react-aria/radio';
import type { RadioGroupState } from '@react-stately/radio';
import { useRadioGroupState } from '@react-stately/radio';
import type { RadioGroupProps } from '@react-types/radio';
import React from 'react';

import styles from './RadioGroup.scss';

export const RadioContext = React.createContext<RadioGroupState>({} as RadioGroupState);

export const RadioGroup: React.FC<React.PropsWithChildren<RadioGroupProps>> = (props) => {
  const state = useRadioGroupState(props);
  const { radioGroupProps, labelProps } = useRadioGroup(props, state);

  return (
    <div
      className={props.orientation === 'horizontal' ? styles.horizontal : ''}
      {...radioGroupProps}
    >
      {props.label && <span {...labelProps}>{props.label}</span>}
      <RadioContext.Provider value={state}>{props.children}</RadioContext.Provider>
    </div>
  );
};
